import { useEffect, useState } from 'react';

interface Countdown {
  percent: number;
  text: string;
}

const useCountDown = ({
  startTime,
  endTime
}: {
  startTime: Date;
  endTime: Date;
}): Countdown => {
  const calculateTimeLeft = () => {
    const nowTime = new Date();
    const totalTime = endTime.getTime() - startTime.getTime();
    const timePassed = nowTime.getTime() - startTime.getTime();
    const difference = endTime.getTime() - nowTime.getTime();

    if (difference > 0) {
      const timeLeftObject = {
        hours: Math.floor(difference / (1000 * 60 * 60)),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60)
      };
      return {
        percent: (timePassed / totalTime) * 100,
        text: `${timeLeftObject.hours} horas, ${timeLeftObject.minutes} minutos, ${timeLeftObject.seconds} segundos`
      };
    }

    return {
      percent: 100,
      text: ''
    };
  };

  const [timeLeft, setTimeLeft] = useState<Countdown>(calculateTimeLeft());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearTimeout(timer);
  }, [endTime, timeLeft]);

  return timeLeft;
};

export default useCountDown;
